import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { CryptocurrenciesPage } from './pages/CryptocurrenciesPage';
import { ExchangesPage } from './pages/ExchangesPage';
import { CryptoDetailPage } from './pages/CryptoDetailPage';
import { ExchangeDetailPage } from './pages/ExchangeDetailPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="flex-1" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/cryptocurrencies" element={<CryptocurrenciesPage data-id="element-8" />} data-id="element-7" />
            <Route path="/exchanges" element={<ExchangesPage data-id="element-10" />} data-id="element-9" />
            <Route path="/cryptocurrency/:id" element={<CryptoDetailPage data-id="element-12" />} data-id="element-11" />
            <Route path="/exchange/:id" element={<ExchangeDetailPage data-id="element-14" />} data-id="element-13" />
          </Routes>
        </main>
        <Footer data-id="element-15" />
      </div>
    </BrowserRouter>;
}